import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { benchmarksApi } from '@/lib/api'
import { queryKeys } from '@/lib/queryClient'
import type { BenchmarkFilters } from '@/types/domain'

export const DEFAULT_BENCHMARK_FILTERS: BenchmarkFilters = { limit: 50, offset: 0 }

export function useBenchmarkRuns(limit = 20) {
  return useQuery({ queryKey: queryKeys.benchmarkRuns(limit), queryFn: () => benchmarksApi.runs(limit) })
}

export function useBenchmarkRun(runUid: string) {
  return useQuery({
    queryKey: queryKeys.benchmarkRun(runUid),
    queryFn: () => benchmarksApi.run(runUid),
    enabled: Boolean(runUid),
  })
}

export function useBenchmarkResults(runUid: string, filters: BenchmarkFilters) {
  return useQuery({
    queryKey: queryKeys.benchmarkResults(runUid, filters),
    queryFn: () => benchmarksApi.results(runUid, filters),
    enabled: Boolean(runUid),
    placeholderData: keepPreviousData,
  })
}
